import React, { useEffect, useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { toast } from "react-toastify";
import NormalSelect from "../form/HorizontalNormalSelect";
import { use } from "react";
import { location } from "../../api";

export const DynamicProblemTypeForm = ({
  onChange,
  selectedProblemTypePrev = [],
}) => {
  const { config, setConfig } = useAuth();
  const [problemTypeWording, setProblemTypeWording] = useState([]);
  const [grouped, setGrouped] = useState([[]]);
  const [selectedProblemType, setSelectedProblemType] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (config) {
      initFirstGroup();
      setProblemTypeWording(config.location_wording.split(","));
    }
  }, [config]);

  const initFirstGroup = async () => {
    const data = await getProblemType();
    const initialGrouped = [data];
    const processAll = [];
    for (let i = 0; i < selectedProblemTypePrev.length; i++) {
      const process = getProblemType(selectedProblemTypePrev[i], i + 2);
      processAll.push(process);
    }
    const datas = await Promise.all(processAll);
    initialGrouped.push(...datas);
    setGrouped(initialGrouped);
    setSelectedProblemType(selectedProblemTypePrev);
  };

  async function getProblemType(parentId = "root", step = "1") {
    try {
      setLoading(true);
      const res = await location.list("", "", parentId, "", "", "", step);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;

        return data;
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  const handleProblemTypeChange = async (e, index) => {
    const newSelectedProblemType = [...selectedProblemType];
    newSelectedProblemType[index] = e.target.value;
    for (let i = index + 1; i < newSelectedProblemType.length; i++) {
      newSelectedProblemType[i] = "";
    }
    setSelectedProblemType(newSelectedProblemType);

    const populatedIndex = index + 1;
    const data = await getProblemType(
      e.target.value || "none",
      populatedIndex + 1
    );
    const copyGrouped = [...grouped];
    copyGrouped[populatedIndex] = data;

    for (let i = populatedIndex + 1; i < copyGrouped.length; i++) {
      copyGrouped[i] = [];
    }
    setGrouped(copyGrouped);

    const cleanedSelected = newSelectedProblemType.filter(
      (problemType) => problemType !== ""
    );
    const latestSelected =
      cleanedSelected.length > 0
        ? cleanedSelected[cleanedSelected.length - 1]
        : null;
    let detailSelected = null;
    for (let i = 0; i < copyGrouped.length; i++) {
      const found = copyGrouped[i].find(
        (problemType) => problemType.id === latestSelected
      );
      if (found) {
        detailSelected = found;
        break;
      }
    }
    onChange(detailSelected, cleanedSelected);
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute top-0 start-0 w-100 h-100"
          style={{
            height: 200,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
        >
          <div className="spinner-grow text-theme"></div>
        </div>
      )}

      {problemTypeWording.map((wording, index) => {
        return (
          <div key={index}>
            <NormalSelect
              key={index}
              value={selectedProblemType[index]}
              label={wording}
              onchange={(e) => handleProblemTypeChange(e, index)}
              list={grouped[index] || []}
              name={`location_id`}
              valueKey="id"
              textKey="location_name"
            />
          </div>
        );
      })}
    </>
  );
};
